<script setup lang="ts">
/**
 * Placeholder for PreviewCard.
 *
 * It intentionally reuses PreviewCard's own class names from `styles/card.css`
 * — the thumbnail's 16:9 aspect-ratio, the two-line title box, the fixed meta
 * row and the fixed action row — so the two components render the *identical*
 * rectangle and nothing on the page moves when the real data arrives.
 */
</script>

<template>
  <div class="card" aria-hidden="true" data-testid="preview-skeleton">
    <div class="card__thumb">
      <div class="sk sk--fill" />
    </div>

    <div class="card__body">
      <div class="card__title card__title--placeholder">
        <div class="sk sk--line" style="width: 86%" />
        <div class="sk sk--line" style="width: 57%" />
      </div>

      <p class="card__meta">
        <span class="sk sk--meta" />
      </p>

      <div class="card__actions">
        <div class="sk sk--button" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.sk--fill {
  width: 100%;
  height: 100%;
  border-radius: 0;
}

.sk--meta {
  display: block;
  width: 42%;
  height: 0.6875rem;
  border-radius: 4px;
}

.sk--button {
  height: 3.25rem;
  border-radius: var(--radius-pill);
}
</style>
